import { LikeOutlined } from '@ant-design/icons';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button/';

export function IncidentOmpSnapshotAcceptButton() {
  const { t } = useTranslation('incidents');

  const label = t(
    'overview.snapshot.acceptKanban',
    'Accept and move to Kanban',
  );

  return (
    <Button
      type="text"
      rounded
      className="incident-omp-snapshot-accept"
      aria-label={label}
      style={{
        height: 'auto',
        minHeight: 'unset',
        padding: 0,
        fontWeight: 600,
        letterSpacing: '0.01em',
        boxShadow: 'none',
      }}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
      }}
    >
      <span className="incident-omp-snapshot-accept__icon-wrap" aria-hidden>
        <LikeOutlined className="incident-omp-snapshot-accept__icon" />
      </span>
      <span className="incident-omp-snapshot-accept__label">{label}</span>
    </Button>
  );
}
